const screenPathMap = {
  Home: '',
  Rank: '/@/realtime',
  Popup: '/@/popup-store',
  Explore: '/@/creator/partners',
  SettingScreen: '/@/mypage',
} as const;

export type PostMessageNavigate = {
  navigate: {
    name:
      | 'Home'
      | 'Rank'
      | 'Popup'
      | 'Creator'
      | 'Shop'
      | 'Explore'
      | 'EmptyScreen'
      | 'SubScreen'
      | 'UtilScreen'
      | 'SignUpSeller'
      | 'SettingScreen'
      | 'Cart'
      | 'SellerStudioScreen';
    params?: {
      uri?: string;
      // 해당 키를 추가하면 앱 상에서 해당 키를 가진 스크린으로 이동합니다.
      override_key?: string;
    };
  };
};

export const makeHomeScreenNavigate = (uri?: string): PostMessageNavigate => {
  return {
    navigate: {
      name: 'Home',
      params: uri
        ? {
            uri,
          }
        : undefined,
    },
  };
};

export const makeScreenResetNavigate = (screen: keyof typeof screenPathMap) => {
  return {
    resetNavigate: {
      sel: `TabNavigation.HomeStack.${screen}`,
      params: {
        uri: `/${T.lang}${screenPathMap[screen]}`,
      },
    },
  };
};

export const makePopupScreenNavigate = (uri?: string): PostMessageNavigate => {
  return {
    navigate: {
      name: 'Popup',
      params: uri
        ? {
            uri,
          }
        : undefined,
    },
  };
};

export const makeRankScreenNavigate = (uri?: string): PostMessageNavigate => {
  return {
    navigate: {
      name: 'Rank',
      params: uri
        ? {
            uri,
          }
        : undefined,
    },
  };
};

export const makeExploreScreenNavigate = (uri?: string): PostMessageNavigate => {
  return {
    navigate: {
      name: 'Explore',
      params: uri
        ? {
            uri,
          }
        : undefined,
    },
  };
};

export const makeEmptyScreenNavigate = (uri: string, override_key?: string): PostMessageNavigate => {
  return {
    navigate: {
      name: 'EmptyScreen',
      params: {
        uri,
        override_key,
      },
    },
  };
};

export const makeSubScreenNavigate = (uri: string): PostMessageNavigate => {
  return {
    navigate: {
      name: 'SubScreen',
      params: {
        uri,
      },
    },
  };
};

export const makeUtilScreenNavigate = (uri: string): PostMessageNavigate => {
  return {
    navigate: {
      name: 'UtilScreen',
      params: {
        uri,
      },
    },
  };
};

export const makeSignUpSellerNavigate = (uri: string): PostMessageNavigate => {
  return {
    navigate: {
      name: 'SignUpSeller',
      params: {
        uri,
      },
    },
  };
};

export const makeSettingScreenNavigate = (): PostMessageNavigate => {
  return {
    navigate: {
      name: 'SettingScreen',
    },
  };
};

export const makeCartNavigate = (): PostMessageNavigate => {
  return {
    navigate: {
      name: 'Cart',
    },
  };
};

export const makeSellerStudioScreenNavigate = (uri: string): PostMessageNavigate => {
  return {
    navigate: {
      name: 'SellerStudioScreen',
      params: {
        uri,
      },
    },
  };
};

export const makeSearchScreenNavigate = (uri: string): PostMessageNavigate => {
  return makeEmptyScreenNavigate(uri, 'SearchResult');
};
